export default "__VITE_ASSET__DCPa$mHt__"